// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3G8LQ","alert":"Contact_alert__1hPQM"};